import * as React from "react";
import { forwardRef } from "react";
const SuccessCheckCircleFillIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#30A66F",
  fillRule: "evenodd",
  d: "M0 8c0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11.1994 5.74788c.1758.1649.1846.44105.0197.6168L7.2272 10.6192c-.16417.175-.43881.1846-.6148.0215L4.80263 8.96384c-.17678-.1638-.1873-.43989-.02351-.61666.1638-.17678.43989-.1873.61667-.0235l1.49168 1.38216 3.69513-3.93831c.1649-.17575.4411-.18454.6168-.01965",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SuccessCheckCircleFillIcon);
export { ForwardRef as SuccessCheckCircleFillIcon };